var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProfileLogo = function SvgProfileLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 21,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.725 10.707c5.794 0 6.162-3.816 6.162-5.21 0-1.392-.369-5.192-6.162-5.192H7.583v19.07H6.254V.305L1.472 1.67l.247.832 2.097-.599v17.471H.938v.867h10.411v-.867H8.47v-8.668h2.256M10.24 1.17c3.323 0 3.766 3.014 3.766 4.328 0 1.313-.443 4.341-3.766 4.341H8.469V1.171z"
  })));
};
export default SvgProfileLogo;